"use client";

import { AlertCircle, ArrowRight, Check, Lightbulb, X } from 'lucide-react';

export const Icons = {
  AlertCircle,
  ArrowRight,
  Check,
  Lightbulb,
  X
};

export default Icons;
